/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Col, Form, Input, Row, Space, Table, Tag } from 'antd';
import PermissionApi from 'apis/PermissionApi';
import { CheckIcon, EditIcon, FilterGoldIcon, FilterIcon } from 'assets/svg';
import MainLayout from 'components/Modules/Layout/MainLayout';
import useQueryParam from 'hooks/useQueryPrams';
import { IGetUserQuery } from 'interface/user.interface';
import { useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import formatDateWithTime from 'utils/formatDateWithTime';
import handleError401 from 'utils/handleError401';
import { HocChangePagination } from 'utils/HocChangePagination';
import { openNotificationWithIcon } from 'utils/notification';
import updateQueryStringParameter from 'utils/updateQueryStringParameter';
import {
  ICreateMappingJobTitle,
  IGroup,
  IJobTitle,
  IJobTitleQuery,
  IMappingJobTitle,
} from 'interface/permission.interface';
import CreateMappingJobTitleModal from 'components/Modules/JobTitle/CreateMappingJobTitleModal';
import UpdateMappingJobTitleModal from 'components/Modules/JobTitle/UpdateMappingJobTitleModal';
import pageTitleStore from 'store/pageTitleStore';
import Button from 'components/Button';
import { Content } from 'antd/es/layout/layout';
import { useForm } from 'antd/es/form/Form';

export default function MappingJobTitlePage(): JSX.Element {
  const [isCreateVisible, setIsCreateVisible] = useState<boolean>(false);
  const [isUpdateVisible, setIsUpdateVisible] = useState<boolean>(false);
  const [currentMappingJobTitle, setCurrentMappingJobTitle] =
    useState<IJobTitle>();

  const history = useHistory();

  const [formSubmitParams, setFormSubmitParams] = useState<any>();

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const queryParam = useQueryParam();

  const [form] = useForm();

  const page = parseInt(queryParam.get('page') + '') || 1;

  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const search = queryParam.get('search') || undefined;
  const active = queryParam.get('active') || undefined;

  const mappingJobTitleParams: IJobTitleQuery = {
    page,
    page_size,
    search,
    active: active === 'true' ? true : active === 'false' ? false : undefined,
  };

  const params = JSON.parse(JSON.stringify(mappingJobTitleParams));

  const userParams = {
    page,
    page_size,
    ...(formSubmitParams && formSubmitParams),
  };

  // const {
  //   data: mappingJobTitle,
  //   refetch: refetchMappingJobTitle,
  //   isLoading: loading,
  // } = useQuery(
  //   ['getMappingJobTitle', mappingJobTitleParams],
  //   () => PermissionApi.queryMappingJobTitle(params),
  //   {
  //     onError: (error: any) => {
  //       if (error.response.data.status === 401) {
  //         handleError401();
  //       }
  //     },
  //   }
  // );

  const { mutate: createMappingJobTitle, isLoading: loadingCreate } =
    useMutation(PermissionApi.mutaionMappingJobTitle, {
      onSuccess: () => {
        // refetchMappingJobTitle();
        // getGroups({ page: 1, page_size: 99999 });
        openNotificationWithIcon('success', 'Thêm MappingJobTitle thành công');
        setIsCreateVisible(false);
      },
      onError: () => {
        openNotificationWithIcon('error', 'Thêm MappingJobTitle  thất bại');
      },
    });

  const { mutate: updateMappingJobTitle, isLoading: loadingUpdate } =
    useMutation(PermissionApi.mutaionMappingJobTitle, {
      onSuccess: () => {
        getMappedJobTitles();
        openNotificationWithIcon('success', 'Cập nhật thành công');
        setIsUpdateVisible(false);
      },
      onError: () => {
        openNotificationWithIcon('error', 'Cập nhật thất bại');
      },
    });

  // const { mutate: getGroups, data: groups } = useMutation(
  //   PermissionApi.getGroups
  // );

  const {
    mutate: getMappedJobTitles,
    data: unAssignJobTitles,
    isLoading,
  } = useMutation(() => PermissionApi.queryJobTitle(userParams));

  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
  };

  const onFinish = (values: any) => {
    const filteredData = Object.fromEntries(
      Object.entries(values).filter(([_, value]) => value !== undefined)
    );
    const stringifiedData: { [key: string]: any } = {};
    Object.keys(filteredData).forEach((key) => {
      stringifiedData[key] = String(filteredData[key]);
    });
    setFormSubmitParams(stringifiedData);
  };

  const handleReset = () => {
    form.resetFields();
    setFormSubmitParams(undefined);
  };

  useEffect(() => {
    setTitle('Cập nhật Role - Job Title');
    setBreadcrumb([{ title: 'Cập nhật Role - Job Title' }]);

    // getGroups({ page: 1, page_size: 99999 });
    getMappedJobTitles();
  }, [page, page_size, formSubmitParams]);

  const columns = [
    {
      title: 'Mã Chức Vụ',
      dataIndex: 'job_title_code',
      width: 140,
    },
    {
      title: 'Tên Chức Vụ',
      dataIndex: 'job_title',
      width: 188,
    },
    {
      title: 'Các quyền',
      dataIndex: 'role',
      width: 188,
      render: (role: any) => {
        return <Tag color="blue">{role}</Tag>;
      },
    },
    // {
    //   width: 200,
    //   title: 'Mô tả',
    //   dataIndex: 'description',
    // },
    // {
    //   title: 'Hoạt động',
    //   dataIndex: 'active',
    //   width: 120,
    //   render: (active: IMappingJobTitle) => {
    //     return (
    //       <div className="flex justify-center">{active && <CheckIcon />}</div>
    //     );
    //   },
    // },
    // {
    //   title: 'Ngày tạo',
    //   dataIndex: 'createdAt',
    //   width: 155,
    //   render: (createdAt: Date) => {
    //     return formatDateWithTime(createdAt);
    //   },
    // },
    // {
    //   title: 'Ngày cập nhật',
    //   dataIndex: 'updatedAt',
    //   width: 155,
    //   render: (updatedAt: Date) => {
    //     return formatDateWithTime(updatedAt);
    //   },
    // },
    {
      title: 'Thao tác',
      fixed: 'right',
      width: 100,
      align: 'center',
      render: (_: any, record: any) => (
        <div className="flex justify-around items-center">
          <button
            onClick={() => {
              setCurrentMappingJobTitle(record);
              setIsUpdateVisible(true);
            }}
          >
            <EditIcon />
          </button>
        </div>
      ),
    },
  ];

  // const onHandleCreate = (values: ICreateMappingJobTitle) => {
  //   createMappingJobTitle(values);
  // };

  const onHandleUpdate = (values: ICreateMappingJobTitle) => {
    console.log(values);
    updateMappingJobTitle(values);
  };

  // const handleOnRowClick = (record: IJobTitle) => {
  //   setCurrentMappingJobTitle(record);
  //   setIsUpdateVisible(true);
  // };

  return (
    <MainLayout isLoading={loadingCreate || loadingUpdate || isLoading}>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        className="mb-1"
      >
        <Col span={12} className="flex justify-end">
          <Space>
            <Button
              bgColor={'bg-white'}
              color={`${
                isOpenFilter ? 'text-primary-50' : 'text-secondary-50'
              }`}
              border={`${
                isOpenFilter ? 'border-primary-50' : 'border-secondary-50'
              }`}
              onClick={toggleFilter}
            >
              {isOpenFilter ? <FilterIcon /> : <FilterGoldIcon />}
              Lọc
            </Button>
          </Space>
        </Col>
      </Row>
      <Form
        form={form}
        layout="vertical"
        className={`items-center ${isOpenFilter ? '' : 'hidden'}`}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Content className="main-content">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col span={6} className="h-[80px]">
              <Form.Item label="Mã chức vụ" name="job_title_code">
                <Input
                  allowClear
                  size="large"
                  placeholder="Mã chức vụ"
                  className="w-full"
                />
              </Form.Item>
            </Col>

            <Col span={6} className="h-[80px]">
              <Form.Item label="Tên chức vụ" name="job_title">
                <Input
                  allowClear
                  size="large"
                  placeholder="Tên chức vụ"
                  className="w-full"
                />
              </Form.Item>
            </Col>

            <Col span={6} className="h-[80px]">
              <Form.Item label="Quyền" name="role">
                <Input
                  allowClear
                  size="large"
                  placeholder="Quyền"
                  className="w-full"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="end"
            className="mt-1.5"
          >
            <Col className="flex justify-end" span={8}>
              <Space>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  onClick={handleReset}
                >
                  Hủy
                </Button>
                <Button type="submit">Tìm kiếm</Button>
              </Space>
            </Col>
          </Row>
        </Content>
      </Form>

      <Content className="main-content mt-4">
        <Table
          rowKey={(record) => record.jobTitleCode}
          columns={columns}
          className="customTable"
          dataSource={unAssignJobTitles?.data}
          scroll={{ x: 958 }}
          // onRow={(record: IJobTitle) => {
          //   return {
          //     onClick: () => handleOnRowClick(record),
          //   };
          // }}
          pagination={{
            className: 'flex items-center',
            current: page,
            pageSize: page_size,
            total: unAssignJobTitles?.total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            onChange: HocChangePagination(history),
          }}
        />
      </Content>
      {/* {/* <CreateJobTitleModal
        isModalVisible={isCreateJobTitleVisible}
        onCancel={() => setIsCreateJobTitleVisible(false)}
        mutationUser={onHandleCreate}
      /> */}

      {/* <CreateMappingJobTitleModal
        isModalVisible={isCreateVisible}
        onCancel={() => setIsCreateVisible(false)}
        mutationUser={onHandleCreate}
        groups={groups?.data}
        jobTitles={unAssignJobTitles?.data}
      /> */}

      <UpdateMappingJobTitleModal
        isModalVisible={isUpdateVisible}
        onCancel={() => setIsUpdateVisible(false)}
        mutationUser={onHandleUpdate}
        jobtitle={currentMappingJobTitle}
      />
    </MainLayout>
  );
}
